import React from 'react';
import WorshipLayout from '@/components/WorshipLayout';
import SetlistLibrary from '@/features/worship/library/SetlistLibrary';
import { useAuth } from '@/context/AuthContext';

// The server decides on every request; these capabilities only hide controls and the page for people who lack them.
const WorshipSetlistLibraryPage = () => {
  const { hasCapability } = useAuth();
  const canView = hasCapability('worship.view_all');
  return (
    <WorshipLayout>
      {canView
        ? <SetlistLibrary canManage={hasCapability('worship.manage')} />
        : <p className="py-12 text-center text-slate-600">Je hebt geen toegang tot de setlistbibliotheek.</p>}
    </WorshipLayout>
  );
};

export default WorshipSetlistLibraryPage;
